/**
 * Bundle selection: syncs selected tier variant to the product form,
 * sticky ATC product/price, and selected styling for tier cards.
 */
if (!customElements.get('bundle-selection')) {
  customElements.define(
    'bundle-selection',
    class BundleSelection extends HTMLElement {
      connectedCallback() {
        this.radios = this.querySelectorAll(
          'input[type="radio"][name^="bundle-selection-"]'
        );
        if (this.radios.length === 0) return;

        this.form =
          document.getElementById(this.dataset.productFormId) ||
          document.querySelector('#product-form-' + this.dataset.sectionId);
        this.stickyAtc = document.querySelector('#sticky-addtocart');

        this.ensureSingleChecked();
        this.syncVariantToForm();
        this.syncStickyAtc();
        this.updateSelectedClasses();

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.onChange());
        });
      }

      ensureSingleChecked() {
        const checked = this.querySelector('input[type="radio"]:checked');
        if (checked) return;
        const first = this.radios[0];
        if (first) first.checked = true;
      }

      onChange() {
        this.updateSelectedClasses();
        this.syncVariantToForm();
        this.syncStickyAtc();
      }

      updateSelectedClasses() {
        this.querySelectorAll('[data-bundle-option]').forEach((el) => {
          const input = el.querySelector('input[type="radio"]');
          el.classList.toggle('is-selected', !!(input && input.checked));
        });
      }

      getCheckedRadio() {
        return this.querySelector('input[type="radio"]:checked');
      }

      syncVariantToForm() {
        const checked = this.getCheckedRadio();
        const variantId = checked?.dataset?.variantId;
        if (!variantId || !this.form) return;

        const variantInput = this.form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const tierQtyRaw = parseInt(
          checked?.dataset?.bundleQuantity ?? '',
          10
        );
        const quantityInput = this.form.querySelector(
          'input[name="quantity"]'
        );
        if (
          quantityInput &&
          !Number.isNaN(tierQtyRaw) &&
          tierQtyRaw > 0
        ) {
          quantityInput.value = String(tierQtyRaw);
          quantityInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }
      }

      syncStickyAtc() {
        if (!this.stickyAtc) return;

        const checked = this.getCheckedRadio();
        if (!checked) return;

        const title = checked.dataset.title;
        const price = checked.dataset.price;
        const priceOld = checked.dataset.priceOld || '';
        const available = checked.dataset.available !== 'false';

        const titleEl = this.stickyAtc.querySelector('.product__title');
        if (titleEl && title) {
          titleEl.textContent = title;
        }

        const priceRoot = this.stickyAtc.querySelector('.price');
        const priceSaleEl = this.stickyAtc.querySelector(
          '.price-item.price-item--sale'
        );
        const priceOldEl = this.stickyAtc.querySelector(
          '.price__sale .price-item.price-item--regular'
        );
        const priceRegularEl = this.stickyAtc.querySelector(
          '.price__regular .price-item.price-item--regular'
        );

        if (price) {
          if (priceSaleEl) priceSaleEl.textContent = price;
          if (priceRegularEl) priceRegularEl.textContent = price;
        }

        if (priceRoot) {
          if (priceOld) {
            priceRoot.classList.add('price--on-sale');
            if (priceOldEl) priceOldEl.textContent = priceOld;
          } else {
            priceRoot.classList.remove('price--on-sale');
          }
        }

        const stickyButton = this.stickyAtc.querySelector('button');
        if (!stickyButton) return;

        if (available) {
          stickyButton.removeAttribute('disabled');
        } else {
          stickyButton.setAttribute('disabled', 'disabled');
        }
      }
    }
  );
}
